<template>
  <alert-filter-component class="scrollable" :filter-types="filterTypes" :filter-change="filterChanged" :filter-list-change="filterListChanged"
    :update-alert="updateAlert" :list-sources="listSources" :alert="alert" />
</template>

<script>
  import AlertFilterComponent from './AlertFilterComponent'
  import { mapActions, mapState } from 'vuex'
  import {
    ALERTS_CHANGE_FILTER,
    ALERTS_CHANGE_LIST_FILTER,
    EDIT_ALERT_DETAILS
  } from '../../../store/action-types'

  export default {
    components: {AlertFilterComponent},
    name: 'alert-filter-container',
    props: {
      alert: {
        type: Object,
        required: true
      }
    },
    mixins: [],
    methods: {
      ...mapActions({
        updateAlert: EDIT_ALERT_DETAILS,
        filterChanged: ALERTS_CHANGE_FILTER,
        filterListChanged: ALERTS_CHANGE_LIST_FILTER
      })
    },
    computed: {
      ...mapState({
        filterTypes: state => state.admin.alertFilterFields,
        listSourcesState: state => state.admin.alertListSources
      }),
      listSources () {
        return this.listSourcesState
      }
    }
  }
</script>

<style scoped>
  .scrollable {
    max-height: calc(100vh - 200px);
    overflow-y: auto;
  }
  @media (max-width: 600px) {
    .scrollable {
      max-height: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertFilterContainer.vue